import { DisplayHeading, Eyebrow, INK, MUTED, Reveal } from './ui';

// Also rendered as FAQPage JSON-LD via the faq prop on Head in pages/index.js.
export const FAQ_ITEMS = [
  {
    question: 'Do I need any technical skills?',
    answer:
      'None at all. There are no servers, plugins or themes to manage — pick a design, connect a domain if you have one, and start writing. We handle hosting, speed, security and backups behind the scenes.',
  },
  {
    question: 'How is this different from a travel theme on WordPress?',
    answer:
      'The travel parts are the platform, not add-ons. Pin a post to a place and TravelFeed builds the country, region and city pages for it, linked to each other and ready for Google. On WordPress that structure is categories and menus you groom by hand for the life of the blog. Maps, photo galleries and day-by-day itineraries are blocks in the editor rather than plugins you install and update, and every post gets share cards made for it, including the vertical pin Pinterest wants. Then there is the part a theme cannot copy: your stories also reach the TravelFeed community, so your blog has readers before it has rankings.',
  },
  {
    question: 'Can I use my own domain name?',
    answer:
      'Yes. Every blog hosting plan lets you connect a domain you own, with SSL set up automatically. A free subdomain is included if you don’t have a domain yet, and you can switch later without losing anything.',
  },
  {
    question: 'I already have a blog elsewhere — can I switch?',
    answer:
      'Yes. Your posts, drafts and pages import from a standard WordPress or Blogger export file, and your domain comes with you, so the address your readers know stays the same. Once a post is published here we archive a permanent copy of every image in it, including the ones still sitting on your old server, so retiring that hosting will not leave holes in your archive. Comments are the one thing that stays behind, and individual post URLs can change. Tell us before you switch and we will help at no extra cost.',
  },
  {
    question: 'How do I actually earn from my blog?',
    answer:
      'Three ways, all built in: display ads (add your Google AdSense code from the dashboard), affiliate links you drop into your posts for the gear and stays you recommend, and optional crypto rewards when the Hive community upvotes your posts. You choose which methods run on your blog.',
  },
  {
    question: 'Do I need to understand crypto?',
    answer:
      'No. Crypto rewards are completely optional — many TravelFeed bloggers never touch them. If you’re curious, cross-posting to Hive is one switch, and we handle the technical side.',
  },
  {
    question: 'What does it cost, and can I cancel?',
    answer:
      'The community membership is $19/year, and blog hosting plans start at $15/month billed yearly. Payments are handled securely by Stripe, and you can cancel anytime.',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="tw-scroll-mt-24 tw-py-20 sm:tw-py-28">
      <div className="tw-mx-auto tw-max-w-3xl tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <Reveal className="tw-text-center">
          <Eyebrow>Before you board</Eyebrow>
          <DisplayHeading className="tw-text-4xl tw-leading-[1.1] sm:tw-text-5xl">
            Questions at the gate.
          </DisplayHeading>
        </Reveal>

        <Reveal className="tw-mt-12">
          <div className="tw-flex tw-flex-col tw-gap-3">
            {FAQ_ITEMS.map(item => (
              <details
                key={item.question}
                className="tw-group tw-rounded-2xl tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-white dark:tw-bg-[#15231E] tw-px-6 tw-py-1 open:tw-pb-5"
              >
                <summary
                  className={`${INK} tw-flex tw-cursor-pointer tw-list-none tw-items-center tw-justify-between tw-gap-4 tw-py-4 tw-text-base tw-font-semibold sm:tw-text-lg [&::-webkit-details-marker]:tw-hidden`}
                >
                  {item.question}
                  <span
                    aria-hidden="true"
                    className="tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-600/10 dark:tw-bg-primary-300/20 tw-text-lg tw-font-medium tw-text-primary-700 dark:tw-text-primary-300 tw-transition-transform tw-duration-200 group-open:tw-rotate-45"
                  >
                    +
                  </span>
                </summary>
                <p className={`${MUTED} tw-m-0 tw-pr-8 tw-text-[15px] tw-leading-relaxed`}>
                  {item.answer}
                </p>
              </details>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
